import PropTypes from 'prop-types';
import { CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  content: {
    height: 330,
    width: 600,
  },
  iframe: {
    border: 0,
    height: 300,
    width: 570,
  },
}));

const NotificationCardContent = ({ isEmail, message }) => {
  const classes = useStyles();

  return (
    <CardContent className={classes.content}>
      {isEmail ? (
        <iframe
          className={classes.iframe}
          sandbox=""
          srcDoc={message}
          title="Message"
        />
      ) : (
        <Typography variant="h6">{message}</Typography>
      )}
    </CardContent>
  );
};

NotificationCardContent.propTypes = {
  isEmail: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default NotificationCardContent;
